import { ReactNode, useCallback, useState } from "react";
import { NavLink, useNavigate } from "react-router";
import { OutboxGesecInvoiceCreateDialog } from "@/services/backend/business-central/components/outbox-gesec-invoice-create-dialog";
import {
  OutboxGesecInvoiceTable,
  OutboxGesecInvoiceTableFilters,
} from "@/services/backend/business-central/components/outbox-gesec-invoice-table";
import { OutboxGesecInvoiceListRequest } from "@/services/backend/business-central/api/outbox-gesec-invoice-api";
import {
  InvoicesPageMain,
  InvoicesPageMainContent,
  InvoicesPageMainHeader,
} from "../../_components/invoices-page";

export function OutboxGesecInvoicesRoute() {
  const [request, setRequest] = useState<OutboxGesecInvoiceListRequest>({});

  const navigate = useNavigate();

  const navigateToInvoice = (outboxId: string) => {
    navigate(`/invoices/business-central/outbox/gesec-invoices/${outboxId}`);
  };

  const renderRowLink = useCallback(
    (outboxId: string, children: ReactNode) => (
      <NavLink
        to={`/invoices/business-central/outbox/gesec-invoices/${outboxId}`}
      >
        {children}
      </NavLink>
    ),
    [],
  );

  return (
    <InvoicesPageMain>
      <InvoicesPageMainHeader
        breadcrumbs={[
          {
            label: "Rechnungsstellung",
            to: "/invoices",
          },
          {
            label: "Business Central",
            to: "/invoices/business-central/outbox",
          },
          {
            label: "Gesec Rechnungen",
            to: "/invoices/business-central/outbox/gesec-invoices",
          },
        ]}
        onNavigateTo={navigate}
      />
      <InvoicesPageMainContent>
        <div className="grid gap-2">
          <div className="flex items-center justify-between">
            <OutboxGesecInvoiceTableFilters
              request={request}
              onRequestChange={setRequest}
            />
            <OutboxGesecInvoiceCreateDialog onSuccess={navigateToInvoice} />
          </div>
          <OutboxGesecInvoiceTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={renderRowLink}
          />
        </div>
      </InvoicesPageMainContent>
    </InvoicesPageMain>
  );
}
